import React, { useEffect, useRef, useState } from 'react'
import useSettingsV2 from '../../hooks/useSettingsV2'

const Button = ({ onClick, label, disabled, type = 'primary', submit, style, loading: forceLoading, icon }: any) => {
  const { settings } = useSettingsV2() as any

  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef<boolean | null>(null)

  useEffect(() => {
    isMountedRef.current = true

    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (typeof forceLoading !== 'undefined') setLoading(forceLoading)
  }, [forceLoading])

  return (
    <button
      style={{
        backgroundColor: settings?.bgPrimaryColor,
        color: settings?.textPrimaryColor,
        ...style,
      }}
      title={label}
      type={submit ? 'submit' : 'button'}
      className={`button is-small is-${type} ${loading && 'is-loading'}`}
      onClick={async event => {
        setLoading(true)
        if (onClick) await onClick(event)
        if (isMountedRef.current) setLoading(false)
      }}
      disabled={disabled}
    >
      {icon ? (
        <span className="icon">
          <i className={`fas ${icon}`} />
        </span>
      ) : (
        label
      )}
    </button>
  )

  // return (
  //   <Button2
  //     disabled={disabled}
  //     loading={loading}
  //     type={type}
  //     htmlType={submit ? 'submit' : 'button'}
  //     onClick={async event => {
  //       setLoading(true)
  //       if (onClick) await onClick(event)
  //       if (isMountedRef.current) setLoading(false)
  //     }}
  //   >
  //     {icon ? (
  //       <span className="icon">
  //         <i className={`fas ${icon}`} />
  //       </span>
  //     ) : (
  //       label
  //     )}
  //   </Button2>
  // )
}

export default Button
